import React, { FC, SyntheticEvent } from "react";
import classnames from "classnames";

interface DayPickerCarouselArrowProps {
  onClick: () => void;
  direction: "prev" | "next";
  display?: boolean;
}

export const DayPickerCarouselArrow: FC<DayPickerCarouselArrowProps> = ({
  onClick,
  direction,
  display = true,
}) => {
  const buttonClass = classnames(
    "prev-next-simple day-picker__prev-next d-none d-sm-block",
    direction,
    {
      "visually-hidden": !display,
    }
  );

  const handleButtonClick = (e: SyntheticEvent) => {
    e.preventDefault();
    onClick();
  };

  return (
    <button className={buttonClass} onClick={handleButtonClick} type="button">
      <span className="visually-hidden">
        {direction === "prev" ? "Bakover" : "Fremover"}
      </span>
    </button>
  );
};
